import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _assignEventsRequest = {};
var _assignEventsResponse = {};
var _bulkAssignEventsAsyncRequest = {};
var _bulkAssignEventsAsyncResponse = {};
var _bulkAssignEventsRequest = {};
var _bulkAssignEventsResponse = { results: '_bulkCategoryResult' };
var _bulkCategoryResult = { item: '_category' };
var _bulkCreateCategoryRequest = { categories: '_category' };
var _bulkCreateCategoryResponse = { results: '_bulkCategoryResult' };
var _bulkUnassignEventsAsyncRequest = {};
var _bulkUnassignEventsAsyncResponse = {};
var _bulkUnassignEventsRequest = {};
var _bulkUnassignEventsResponse = { results: '_bulkCategoryResult' };
var _category = { createdDate: 'google.protobuf.Timestamp' };
var _createCategoryRequest = { category: '_category' };
var _createCategoryResponse = { category: '_category' };
var _deleteCategoryRequest = {};
var _deleteCategoryResponse = {};
var _listEventCategoriesRequest = {};
var _listEventCategoriesResponse = { categories: '_category' };
var _queryCategoriesRequest = {};
var _queryCategoriesResponse = { categories: '_category' };
var _reorderCategoryEventsRequest = {};
var _reorderCategoryEventsResponse = {};
var _unassignEventsRequest = {};
var _unassignEventsResponse = {};
var _updateCategoryRequest = { category: '_category' };
var _updateCategoryResponse = { category: '_category' };
function resolveWixEventsCategoriesCategoryManagementUrl(opts) {
    var domainToMappings = {
        'events._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
        ],
        'www.wixevents.com': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/api',
                destPath: '/api',
            },
            {
                srcPath: '/viewEvent',
                destPath: '/viewEvent',
            },
            {
                srcPath: '/viewRsvpDashboard',
                destPath: '/viewRsvpDashboard',
            },
            {
                srcPath: '/viewOrderDashboard',
                destPath: '/viewOrderDashboard',
            },
            {
                srcPath: '/viewSummarySubscription',
                destPath: '/viewSummarySubscription',
            },
            {
                srcPath: '/check-in',
                destPath: '/check-in',
            },
            {
                srcPath: '/oc',
                destPath: '/oc',
            },
            {
                srcPath: '/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/export',
                destPath: '/export',
            },
            {
                srcPath: '/tickets',
                destPath: '/tickets',
            },
            {
                srcPath: '/payment-redirect',
                destPath: '/payment-redirect',
            },
            {
                srcPath: '/admin',
                destPath: '/admin',
            },
            {
                srcPath: '/ticket',
                destPath: '/ticket',
            },
            {
                srcPath: '/media',
                destPath: '/media',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-events-web',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/events/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/events/v2',
                destPath: '/v2',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/events/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/events/v1/notifications',
                destPath: '/v1/notifications',
            },
            {
                srcPath: '/events/v1/reports',
                destPath: '/v1/reports',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/site',
                destPath: '/v1/site',
            },
            {
                srcPath: '/events/v1/web',
                destPath: '/v1/web',
            },
            {
                srcPath: '/events/v2/tickets',
                destPath: '/v2/tickets',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new category. */
export function createCategory(payload) {
    var _a = serializer(_createCategoryRequest, { _category: _category }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCategoryResponse, {
        _category: _category,
    }).fromJSON;
    function __createCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'POST',
            methodFqn: 'wix.events.categories.CategoryManagement.CreateCategory',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCategory.fromReq = fromReq;
    __createCategory.__isAmbassador = true;
    return __createCategory;
}
/** Creates new categories. */
export function bulkCreateCategory(payload) {
    var _a = serializer(_bulkCreateCategoryRequest, { _category: _category }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateCategoryResponse, {
        _bulkCategoryResult: _bulkCategoryResult,
        _category: _category,
    }).fromJSON;
    function __bulkCreateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'POST',
            methodFqn: 'wix.events.categories.CategoryManagement.BulkCreateCategory',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/bulk/categories/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateCategory.fromReq = fromReq;
    __bulkCreateCategory.__isAmbassador = true;
    return __bulkCreateCategory;
}
/** Updates an existing category. */
export function updateCategory(payload) {
    var _a = serializer(_updateCategoryRequest, { _category: _category }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCategoryResponse, {
        _category: _category,
    }).fromJSON;
    function __updateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'PATCH',
            methodFqn: 'wix.events.categories.CategoryManagement.UpdateCategory',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/categories/{category.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCategory.fromReq = fromReq;
    __updateCategory.__isAmbassador = true;
    return __updateCategory;
}
/** Deletes existing category. */
export function deleteCategory(payload) {
    var _a = serializer(_deleteCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCategoryResponse, {}).fromJSON;
    function __deleteCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'DELETE',
            methodFqn: 'wix.events.categories.CategoryManagement.DeleteCategory',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCategory.fromReq = fromReq;
    __deleteCategory.__isAmbassador = true;
    return __deleteCategory;
}
/**
 * - `filter` - supported for `name`, `id` and `states` fields.
 * - `sort` - supported for `created` and `name` fields.
 * - `paging` - supported, see [paging](https://dev.wix.com/api/rest/getting-started/pagination).
 * - `fields` - not supported.
 * - `fieldsets` - not supported.
 * - `cursorPaging` - not supported, use offset pagination instead.
 */
export function queryCategories(payload) {
    var _a = serializer(_queryCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCategoriesResponse, {
        _category: _category,
    }).fromJSON;
    function __queryCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'POST',
            methodFqn: 'wix.events.categories.CategoryManagement.QueryCategories',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/categories/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCategories.fromReq = fromReq;
    __queryCategories.__isAmbassador = true;
    return __queryCategories;
}
/** Assigns events to a single category. */
export function assignEvents(payload) {
    var _a = serializer(_assignEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignEventsResponse, {}).fromJSON;
    function __assignEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'POST',
            methodFqn: 'wix.events.categories.CategoryManagement.AssignEvents',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/categories/{categoryId}/events',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignEvents.fromReq = fromReq;
    __assignEvents.__isAmbassador = true;
    return __assignEvents;
}
/** Assigns events to multiple categories. */
export function bulkAssignEvents(payload) {
    var _a = serializer(_bulkAssignEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAssignEventsResponse, {
        _bulkCategoryResult: _bulkCategoryResult,
        _category: _category,
    }).fromJSON;
    function __bulkAssignEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'POST',
            methodFqn: 'wix.events.categories.CategoryManagement.BulkAssignEvents',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/bulk/categories/events',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAssignEvents.fromReq = fromReq;
    __bulkAssignEvents.__isAmbassador = true;
    return __bulkAssignEvents;
}
/** Assigns filtered events to multiple categories. */
export function bulkAssignEventsAsync(payload) {
    var _a = serializer(_bulkAssignEventsAsyncRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkAssignEventsAsyncResponse, {}).fromJSON;
    function __bulkAssignEventsAsync(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'POST',
            methodFqn: 'wix.events.categories.CategoryManagement.BulkAssignEventsAsync',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/bulk-async/categories/assign-events-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkAssignEventsAsync.fromReq = fromReq;
    __bulkAssignEventsAsync.__isAmbassador = true;
    return __bulkAssignEventsAsync;
}
/** Unassigns events from a single category. */
export function unassignEvents(payload) {
    var _a = serializer(_unassignEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unassignEventsResponse, {}).fromJSON;
    function __unassignEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'DELETE',
            methodFqn: 'wix.events.categories.CategoryManagement.UnassignEvents',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/categories/{categoryId}/events',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unassignEvents.fromReq = fromReq;
    __unassignEvents.__isAmbassador = true;
    return __unassignEvents;
}
/** Unassigns events from multiple categories. */
export function bulkUnassignEvents(payload) {
    var _a = serializer(_bulkUnassignEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUnassignEventsResponse, {
        _bulkCategoryResult: _bulkCategoryResult,
        _category: _category,
    }).fromJSON;
    function __bulkUnassignEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'DELETE',
            methodFqn: 'wix.events.categories.CategoryManagement.BulkUnassignEvents',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/bulk/categories/events',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUnassignEvents.fromReq = fromReq;
    __bulkUnassignEvents.__isAmbassador = true;
    return __bulkUnassignEvents;
}
/** Unassigns filtered events from multiple categories. */
export function bulkUnassignEventsAsync(payload) {
    var _a = serializer(_bulkUnassignEventsAsyncRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUnassignEventsAsyncResponse, {}).fromJSON;
    function __bulkUnassignEventsAsync(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'POST',
            methodFqn: 'wix.events.categories.CategoryManagement.BulkUnassignEventsAsync',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/bulk-async/categories/unassign-events-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUnassignEventsAsync.fromReq = fromReq;
    __bulkUnassignEventsAsync.__isAmbassador = true;
    return __bulkUnassignEventsAsync;
}
/** Lists visible event categories. */
export function listEventCategories(payload) {
    var _a = serializer(_listEventCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEventCategoriesResponse, {
        _category: _category,
    }).fromJSON;
    function __listEventCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'GET',
            methodFqn: 'wix.events.categories.CategoryManagement.ListEventCategories',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/categories/{eventId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEventCategories.fromReq = fromReq;
    __listEventCategories.__isAmbassador = true;
    return __listEventCategories;
}
/** Change the order of category events. */
export function reorderCategoryEvents(payload) {
    var _a = serializer(_reorderCategoryEventsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reorderCategoryEventsResponse, {}).fromJSON;
    function __reorderCategoryEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.category',
            method: 'POST',
            methodFqn: 'wix.events.categories.CategoryManagement.ReorderCategoryEvents',
            url: resolveWixEventsCategoriesCategoryManagementUrl({
                protoPath: '/v1/categories/{categoryId}/reorder',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reorderCategoryEvents.fromReq = fromReq;
    __reorderCategoryEvents.__isAmbassador = true;
    return __reorderCategoryEvents;
}
//# sourceMappingURL=http.impl.js.map